import React, { useState } from 'react';
import { Card, Typography, Space, Button, Radio, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { ProteinAnalysisTask } from '../../../../api/proteinService';

const { Title } = Typography;

interface SignalPeptideFormProps {
  task: ProteinAnalysisTask;
  onSubmit: (task: ProteinAnalysisTask, organism: string) => void;
  isLoading: boolean;
}

const SignalPeptideForm: React.FC<SignalPeptideFormProps> = ({ task, onSubmit, isLoading }) => {
  const [organism, setOrganism] = useState<string>('euk');

  const handleSubmit = () => {
    onSubmit(task, organism);
  };

  return (
    <Card 
      title={
        <Space>
          <span>信号肽预测</span>
          <Tooltip title="DeepSig预测蛋白质信号肽，支持真核生物、革兰氏阳性菌和革兰氏阴性菌">
            <InfoCircleOutlined />
          </Tooltip>
        </Space>
      } 
      style={{ marginBottom: 16 }}
    >
      <Space direction="vertical" style={{ width: '100%' }}>
        <div>
          <Title level={5}>生物类型选择</Title>
          <Radio.Group 
            value={organism} 
            onChange={(e) => setOrganism(e.target.value)}
            buttonStyle="solid"
            style={{ marginBottom: 16 }}
          >
            <Radio.Button value="euk">Eukarya</Radio.Button>
            <Radio.Button value="gramp">Gram-positive</Radio.Button>
            <Radio.Button value="gramn">Gram-negative</Radio.Button>
          </Radio.Group>
        </div>
        
        <Button 
          type="primary" 
          onClick={handleSubmit} 
          loading={isLoading}
        >
          预测信号肽
        </Button>
      </Space>
    </Card>
  );
};

export default SignalPeptideForm; 